import { render } from "./ServicioPublico.vue?vue&type=template&id=a8368d40&scoped=true"
import script from "./ServicioPublico.vue?vue&type=script&lang=js"
export * from "./ServicioPublico.vue?vue&type=script&lang=js"

import "./ServicioPublico.vue?vue&type=style&index=0&id=a8368d40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8368d40"]])

export default __exports__